import { createUseStyles } from "react-jss"
import { Colors } from "../../constants/colors"
import { CreditorFunding } from "../../redux/types"
import Card from "../Card"
import { formatMoney } from "../../utils/moneyHelper"

interface Props {
  fundingOverview: CreditorFunding[]
}

const CreditorFundingList = ({fundingOverview}: Props) => {
    const styles = useStyles()

    const renderHeader = () => {
        return (
          <Card className={styles.container}>
            <div className={styles.cell}>
              <p>Creditor</p>
            </div>
            <div className={styles.cell}>
              <p>Type</p>
            </div>
            <div className={styles.cell}>
              <p>Postfunding credit usage</p>
            </div>
            <div className={styles.cell}>
              <p>Postfunding paid amount</p>
            </div>
            <div className={styles.cell}>
              <p>Postfunding credit limit</p>
            </div>
            <div className={styles.cell}>
                Available credit space
            </div>
          </Card>
        )
      }
    
    const renderItems = () => {
        return fundingOverview?.map((creditor, index) => {
            return (
                <Card className={styles.container} key={`token${index}`}>
                    <div className={styles.cell}>
                        <p><span>{creditor.creditorName}</span></p>
                    </div>
                    <div className={styles.cell}>
                        <p><span>{creditor.type}</span></p>
                    </div>
                    <div className={styles.cell}>
                        <p><span>{creditor.creditUsage && formatMoney(creditor.creditUsage)}</span></p>
                    </div>
                    <div className={styles.cell}>
                        <p><span>{creditor.postfundedAmount && formatMoney(creditor.postfundedAmount)}</span></p>
                    </div>
                    <div className={styles.cell}>
                        <p><span>{creditor.creditUsageLimit && formatMoney(creditor.creditUsageLimit)}</span></p>
                    </div>
                    <div className={styles.cell}>
                        <p><span>{creditor.remainingCreditSpace && formatMoney(creditor.remainingCreditSpace)}</span></p>
                    </div>
                </Card>
            )
        })
    }

    return (
    <div>
        {renderHeader()}
        {renderItems()}
    </div>
  )
}

export default CreditorFundingList

const useStyles = createUseStyles({
  container: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    textAlign: 'left',
    padding: '3px 20px',
    margin: '10px 0',
    transition: '0.4s',
    '&:hover': {
      backgroundColor: Colors.darkGrayHover,
    }
  },
  header: {
    margin: '30px 0 20px 0',
  },
  cell: {
    flex: 1,
    padding: '0px 10px'
  },
})